export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_MSAL_CLIENT_ID,
    authority: `https://login.microsoftonline.com/${process.env.REACT_APP_MSAL_TENANT_ID}`,
    redirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
};

// Scopes for login. The API scope causes MSAL to issue an access token with
// aud = MSAL_CLIENT_ID, which the backend can properly validate.
export const loginRequest = {
  scopes: ['openid', 'profile', 'email'],
};

// Scopes requested when calling the compute optimiser API.
// acquireTokenSilent will return an access token (not an ID token) with
// audience = the app's client ID, which the backend verifies.
export const apiRequest = {
  scopes: [`api://${process.env.REACT_APP_MSAL_CLIENT_ID}/access_as_user`],
};
